import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import { types } from 'mobx-state-tree';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
const getCompaniesListAsync = createAsync(body => {
  return async function getCompaniesList(options) {
    const resp = await api.AdminApi.getCompaniesList(body, options);
    return resp;
  };
});
const createPMAccountAsync = createAsync(body => {
  return async function createPMAccount(options) {
    const resp = await api.AdminApi.createPMAccount(body, options);
    return resp;
  };
});
const createCompanyAsync = createAsync(body => {
  return async function createCompany(options) {
    const resp = await api.AdminApi.createCompany(body, options);
    return resp;
  };
});
const getCompanyByIdAsync = createAsync(companyId => {
  return async function getCompanyById(options) {
    const resp = api.AdminApi.getCompanyById({
      companyId
    }, options);
    return resp;
  };
});
const getAdminAccountLoginImpersonateAsync = createAsync(body => {
  return async function getAdminAccountLoginImpersonate(options) {
    const resp = await api.AdminApi.getAdminAccountImpersonate(body, options);
    return resp;
  };
});
const createAdminAccountAsync = createAsync(body => {
  return async function createAdminAccount(options) {
    const resp = await api.AdminApi.createAdminAccount(body, options);
    return resp;
  };
});
const getAdminAccountsAsync = createAsync(() => {
  return async function getAdminAccounts(options) {
    const resp = await api.AdminApi.getAdminAccounts(options);
    return resp;
  };
});
const deleteAdminAccountAsync = createAsync(body => {
  return async function deleteAdminAccount(options) {
    const resp = await api.AdminApi.deleteAdminAccount(body, options);
    return resp;
  };
});
const updateAdminAccountAsync = createAsync(body => {
  return async function updateAdminAccount(options) {
    const resp = await api.AdminApi.updateAdminAccount(body, options);
    return resp;
  };
});
const adminSettings = types.model({
  companyId: types.optional(types.string, ''),
  companyName: types.optional(types.string, ''),
  isAdminSwitchToNewAccount: types.optional(types.boolean, false)
});
const AdminStore = types.model('AdminStore', {
  settings: types.optional(adminSettings, {}),
  getCompaniesListAsync,
  createPMAccountAsync,
  createCompanyAsync,
  getCompanyByIdAsync,
  createAdminAccountAsync,
  getAdminAccountLoginImpersonateAsync,
  getAdminAccountsAsync,
  deleteAdminAccountAsync,
  updateAdminAccountAsync
}).actions(store => {
  return {
    saveSelectedCompanyName(name) {
      try {
        store.settings.companyName = name !== null && name !== void 0 ? name : 'Select account';
        localStorage.setItem(USER_SETTINGS_KEYS.companyName, name || 'Select account');
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setIsAdminSwitchToNewAccount(state) {
      try {
        store.settings.isAdminSwitchToNewAccount = state;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get companyName() {
    if (!store.settings.companyName) {
      store.saveSelectedCompanyName(localStorage.getItem(USER_SETTINGS_KEYS.companyName));
    }
    return localStorage.getItem(USER_SETTINGS_KEYS.companyName) || 'Select account';
  },
  get companyId() {
    return localStorage.getItem(USER_SETTINGS_KEYS.company);
  },
  get isAdminSwitchToNewAccount() {
    return store.settings.isAdminSwitchToNewAccount;
  }
}));
export const admin = types.optional(AdminStore, {});